import { toPriceCurrency } from '@/utils/filters'

export default function ({ disabledAdd, fnClassButton, isStatusAvailable }) {
  return {
    isAutoLoad: false,
    store: {
      get: {
        url: 'Stocks/GetAllDynamic',
        selected: [
          'id', 'id as stockID', 'status.title as statusTitle',
          'ppwPath', 'stockLocation.title as locationTitle', 'partID', 'entryDate', 'supplierCompanyID',
          'supplierCompany.name as supplierCompanyName', 'partSN', 'sellPrice', 'partPrice', 'priceCurrencyID',
          'sellExchCurrency.title as currencyTitle',
          'conditionID', 'condition.title as conditionTitle', 'releaseID', 'release.title as releaseTitle',
          'traceabilityCompanyID', 'traceabilityCompany.name as traceabilityCompanyName', 'tagInfoCompanyID',
          'tagInfoCompany.name as tagInfoCompanyName', 'tagDate', 'sellExchCurrencyID', 'exchPrice', 'statusID'
        ],
        filters: `partSN != null && statusID != 2`
      }
    },
    columns: [
      {
        // eslint-disable-next-line no-template-curly-in-string
        title: '${root.L10n("part-sn")}',
        field: 'partSN'
      },
      {
        // eslint-disable-next-line no-template-curly-in-string
        title: '${root.L10n("condition")}',
        field: 'conditionTitle',
        sortable: {
          custom: 'condition.title'
        }
      },
      {
        // eslint-disable-next-line no-template-curly-in-string
        title: '${root.L10n("release")}',
        field: 'releaseTitle',
        sortable: {
          custom: 'release.title'
        }
      },
      {
        // eslint-disable-next-line no-template-curly-in-string
        title: '${root.L10n("tag-date")}',
        field: 'tagDate',
        template: 'date'
      },
      {
        // eslint-disable-next-line no-template-curly-in-string
        title: '${root.L10n("rep-shop")}',
        field: 'tagInfoCompanyName',
        sortable: {
          custom: 'tagInfoCompany.name'
        }
      },
      {
        // eslint-disable-next-line no-template-curly-in-string
        title: '${root.L10n("price")}',
        field: 'sellPrice',
        template: (data) => toPriceCurrency(data.sellPrice, data.currencyTitle)
      }
    ],
    sortable: {
      field: 'entryDate',
      order: 'desc'
    },
    header: {
      isVisible: false
    },
    rowControls: {
      left: {
        controls: [
          {
            type: 'custom',
            // eslint-disable-next-line no-template-curly-in-string
            title: '${root.L10n("add-to-quote")}',
            buttonClass: fnClassButton,
            disabled: () => (disabledAdd)
          }
        ]
      }
    }
  }
}
